import axios from "axios";
import { API_ENDPOINTS } from "../api-urls";

// Helper function to handle API requests
const handleRequest = async (requestFn, endpoint) => {
  try {
    console.log(`Making API request to: ${endpoint}`); // Log before request
    const response = await requestFn();
    console.log(`Response received from: ${endpoint}`, response.data); // Log after success
    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }
  } catch (error) {
    console.error(`API Error at ${endpoint}:`, error.response?.data || error.message);
    throw error;
  }
};
const getAuthToken = () => {
  const token = localStorage.getItem("authToken");
  return token ? `Bearer ${token}` : null;
};

// Get all orders for a user
export const fetchUserOrdersAPI = async () => {
  const token = getAuthToken();
  const user_id = localStorage.getItem("user_id");
  if (!token || !user_id) throw new Error("Authentication token missing.");
  

  const endpoint = `${API_ENDPOINTS.orders}`;
  return handleRequest(
    () =>
      axios.get(endpoint, {
        headers: { Authorization: token },
      }),
    endpoint
  );
};

// Get order details by ID
export const fetchOrderDetailsByIdAPI = async (orderId) => {
  const token = getAuthToken();
  const user_id = localStorage.getItem("user_id");
  if (!token || !user_id) throw new Error("Authentication token missing.");
  

  const endpoint = `${API_ENDPOINTS.orders}getOrderDetailsById/${orderId}`;
  return handleRequest(() => axios.get(endpoint,{
    headers: { Authorization: token },
  }),
   endpoint);
};

// Create a new order

export const createOrderAPI = async (orderData) => {
  const token = getAuthToken();
  const user_id = localStorage.getItem("user_id");
  if (!token || !user_id) throw new Error("Authentication token missing.");
  
  const endpoint = `${API_ENDPOINTS.orders}`;
  return handleRequest(() => axios.post(endpoint, orderData,{
    headers: { Authorization: token }
  }), 
  endpoint,);
};

export const verifyPayment = async (data) => {
  const token = getAuthToken();
  const user_id = localStorage.getItem("user_id");
  if (!token || !user_id) throw new Error("Authentication token missing.");
  console.log("verify payment data------", data);
  const endpoint = `${API_ENDPOINTS.verifyPayment}`;
  return handleRequest(() => axios.post(endpoint, data,{
    headers: { Authorization: token }
  }), 
  endpoint,);
};

// Update an existing order
export const updateOrderAPI = async (orderId, updatedOrderData) => {
  const endpoint = `${API_ENDPOINTS.orders}/update/${orderId}`;
  return handleRequest(() => axios.put(endpoint, updatedOrderData), endpoint);
};

// Cancel an order
export const cancelOrderAPI = async (orderId) => {
  const endpoint = `${API_ENDPOINTS.orders}/cancel/${orderId}`;
  return handleRequest(() => axios.post(endpoint), endpoint);
};

// Return a product
export const returnProductAPI = async (returnData) => {
  const endpoint = `${API_ENDPOINTS.orders}/return`;
  return handleRequest(() => axios.post(endpoint, returnData), endpoint);
};

// Add notes to an order
export const addNotesToOrderAPI = async (orderId, notesData) => {
  const endpoint = `${API_ENDPOINTS.orders}/notes/${orderId}`;
  return handleRequest(() => axios.post(endpoint, notesData), endpoint);
};


// import axios from "axios";
// import { API_ENDPOINTS } from "../api-urls";

// // Helper function to handle API requests
// const handleRequest = async (requestFn, endpoint) => {
//   try {
//     console.log(`Making API request to: ${endpoint}`); // Log before request
//     const response = await requestFn();
//     console.log(`Response received from: ${endpoint}`, response.data); // Log after success
//     if (response.status >= 200 && response.status < 300) {
//       return response.data;
//     } else {
//       throw new Error(`Error: ${response.status} - ${response.statusText}`);
//     }
//   } catch (error) {
//     console.error(`API Error at ${endpoint}:`, error.response?.data || error.message);
//     throw error;
//   }
// };

// // Function to get authentication token
// const getAuthToken = () => {
//   const token = localStorage.getItem("authToken");
//   return token ? `Bearer ${token}` : null;
// };

// // Get all orders for a user
// export const fetchUserOrdersAPI = async () => {
//   const token = getAuthToken();
//   const user_id = localStorage.getItem("user_id");
//   if (!token || !user_id) throw new Error("Authentication token missing.");

//   const endpoint = `${API_ENDPOINTS.orders}`;
//   return handleRequest(
//     () =>
//       axios.get(endpoint, {
//         headers: { Authorization: token },
//       }),
//     endpoint
//   );
// };

// // Get order details by ID
// export const fetchOrderDetailsByIdAPI = async (orderId) => {
//   const token = getAuthToken();
//   const user_id = localStorage.getItem("user_id");
//   if (!token || !user_id) throw new Error("Authentication token missing.");

//   const endpoint = `${API_ENDPOINTS.orders}getOrderDetailsById/${orderId}`;
//   return handleRequest(
//     () =>
//       axios.get(endpoint, {
//         headers: { Authorization: token },
//       }),
//     endpoint
//   );
// };

// // Create a new order with Razorpay integration
// export const createOrderAPI = async (orderData) => {
//   const token = getAuthToken();
//   const user_id = localStorage.getItem("user_id");
//   if (!token || !user_id) throw new Error("Authentication token missing.");

//   const endpoint = `${API_ENDPOINTS.orders}`;
//   try {
//     // Step 1: Create order in backend
//     const order = await handleRequest(
//       () =>
//         axios.post(endpoint, orderData, {
//           headers: { Authorization: token },
//         }),
//       endpoint
//     );

//     if (!order || !order.id) throw new Error("Failed to create order.");

//     // Step 2: Initialize Razorpay Payment UI
//     const options = {
//       key: "YOUR_RAZORPAY_KEY", // Replace with actual Razorpay Key ID
//       amount: order.amount,
//       currency: order.currency,
//       name: "Your Company Name",
//       description: "Order Payment",
//       order_id: order.id, // Razorpay Order ID
//       handler: async function (response) {
//         // Step 3: Call verify payment API
//         const verificationData = {
//           razorpay_order_id: response.razorpay_order_id,
//           razorpay_payment_id: response.razorpay_payment_id,
//           razorpay_signature: response.razorpay_signature,
//         };

//         try {
//           const verificationResponse = await verifyPaymentAPI(verificationData);
//           if (verificationResponse.success) {
//             alert("Payment Successful!");
//             // Redirect or update UI as needed
//           } else {
//             alert("Payment Verification Failed!");
//           }
//         } catch (error) {
//           alert("Payment Verification Failed!");
//           console.error(error);
//         }
//       },
//       prefill: {
//         name: "User Name", // Replace with actual user name
//         email: "user@example.com", // Replace with actual email
//         contact: "9999999999", // Replace with actual phone number
//       },
//       theme: {
//         color: "#3399cc",
//       },
//     };

//     // Open Razorpay Payment UI
//     const razorpayInstance = new window.Razorpay(options);
//     razorpayInstance.open();
//   } catch (error) {
//     console.error("Error in createOrderAPI:", error);
//     throw error;
//   }
// };

// // Verify Payment API
// export const verifyPaymentAPI = async (verificationData) => {
//   const token = getAuthToken();
//   const endpoint = `${API_ENDPOINTS.payment}/verifyPayment`;

//   return handleRequest(
//     () =>
//       axios.post(endpoint, verificationData, {
//         headers: { Authorization: token },
//       }),
//     endpoint
//   );
// };

// // Update an existing order
// export const updateOrderAPI = async (orderId, updatedOrderData) => {
//   const endpoint = `${API_ENDPOINTS.orders}/update/${orderId}`;
//   return handleRequest(() => axios.put(endpoint, updatedOrderData), endpoint);
// };

// // Cancel an order
// export const cancelOrderAPI = async (orderId) => {
//   const endpoint = `${API_ENDPOINTS.orders}/cancel/${orderId}`;
//   return handleRequest(() => axios.post(endpoint), endpoint);
// };

// // Return a product
// export const returnProductAPI = async (returnData) => {
//   const endpoint = `${API_ENDPOINTS.orders}/return`;
//   return handleRequest(() => axios.post(endpoint, returnData), endpoint);
// };

// // Add notes to an order
// export const addNotesToOrderAPI = async (orderId, notesData) => {
//   const endpoint = `${API_ENDPOINTS.orders}/notes/${orderId}`;
//   return handleRequest(() => axios.post(endpoint, notesData), endpoint);
// };
